import AreaOfStudyTypeDomainService from "../../../Domain/AreaOfStudyType/AreaOfStudyType.service";
import makeAreaOfStudyLookup from "./AreaOfStudyLookup";
const ConcentrationLookup = makeAreaOfStudyLookup(AreaOfStudyTypeDomainService.CONCENTRATION_ID);
export default ConcentrationLookup;
